<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container" :style="'height:'+fullHeight+'px;'">  <!-- :style="'height:'+fullHeight+'px;'" -->
      <div class="top">
        <div class="header">
          <a href="#">
            <!-- <img src="~@/assets/logo.png" class="logo" alt="logo"> -->
            <!-- <span class="title">物联网终端管理平台</span> -->
          </a>
        </div>
      </div>

      <route-view></route-view>
      <!-- <div class="footer">
        <div class="copyright">
          Copyright &copy; 2020 <a href="#">物联网终端管理平台</a>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import RouteView from "@/components/layouts/RouteView"
  import { mixinDevice } from '@/utils/mixin.js'

  export default {
    name: "UserLayout",
    components: { RouteView },
    mixins: [mixinDevice],
    data () {
      return {
        fullHeight: document.documentElement.clientHeight
      }
    },
    watch:{
      fullHeight (val) {  //监控浏览器高度变化
        if(!this.timer) {
          this.fullHeight = val
          this.timer = true
          let that = this
          setTimeout(() => {
            that.timer = false
          }, 400);
        }
      }
    },
    mounted () {
      document.body.classList.add('userLayout')
      this.get_bodyHeight()
    },
    methods: {
      get_bodyHeight(){   //动态获取浏览器高度
        const that = this
        window.onresize = () => {
          return (() => {
            window.fullHeight = document.documentElement.clientHeight
            that.fullHeight = window.fullHeight
          })
        }
      }
    },
    beforeDestroy () {
      document.body.classList.remove('userLayout')
    },
  }
</script>

<style lang="less" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;
    &.mobile {
      .container {
        .main {
          max-width: 480px;
          width: 98%;
        }
      }
    }
    .container {
      width: 100%;
      height: 100%;
      min-height: 100%;
      // background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
      background: url('../../assets/beijing710.png') no-repeat 50%;
      background-size: 100% 100%;
      position: fixed;
      a {
        text-decoration: none;
      }
      .top {
        margin-left: 60%;
        .header {
          height: 44px;
          line-height: 44px;
          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
             margin: 0px 330px 0px auto;
          }
          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }
          .title {
            font-size: 33px;
            color: rgba(255, 255, 255, .85);
            font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            font-weight: 600;
            position: relative;
            margin-left: auto;
            top: 160px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }
      .main {
        height: calc(100% - 44px);
        min-width: 260px;
        width: 480px;
        //margin-left: 59%;
        float: right;
        margin-right: 200px;
        margin-bottom: 10%;
        align-items: center;
        display: flex;
      }
      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 24px 0 24px;
        text-align: center;
        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
</style>